/* eslint-disable import/prefer-default-export */

export const Push = (url) => {
  window.location.assign(url);
};
